// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"86f9eb284ecec30b2a85","532":"af30a440a4216273277c","589":"a6fe656fc91627e730de","678":"3f2263c762ee7e8581cc","883":"8ac04198556e904dcc39"}[chunkId] + ".js";
};